<template>
  <div id="upload-demo">
    <vx-card title="Upload Excel File here">
      <div class="demo-alignment">
      <input v-if="uploadbtn" type="file" class="uploadBtn" @change="selectedFile"/>
      <vs-button v-if="uploadbtn" @click="uploadExcel">Upload Excel</vs-button>
      <h4 v-if="excelUploadLoad">Uploading....Please Wait...</h4><h4 v-if="uploadExcelDone">Upload Complete.</h4>
      <vs-button v-if="uploadExcelDone" @click="compareApp">Compare Application</vs-button>
      <h4 v-if="excelCompareLoad">Comparing....Please Wait...</h4><h4 v-if="compareExcelDone">Compare Done.</h4>
      <vs-button v-if="compareExcelDone" @click="downloadPur">Download as Excel</vs-button>
      </div>

    </vx-card>
    <br>

    <div class="vx-col w-full">
      <vx-card title="Compared Data List">
        <!--<template slot="actions">
          <div class="demo-alignment">
            <vs-input placeholder="Enter Sales Doc" v-model="searchParam.sales_doc"/>
            <vs-input placeholder="Enter Mobile No" v-model="searchParam.mobile_number"/>
            <vs-button color="rgb(0 121 193)" icon-pack="feather" icon="icon-search"
                       @click="searchExcelData(searchParam)"></vs-button>
          </div>
        </template>-->

            <br>

              <vs-table stripe
                        :sst="true"
                        @change-page="handleChangePage"
                        v-model="selected"
                        :total="compareData.total"
                        pagination
                        max-items="50"
                        :data="compareData.data">
                <!--<template slot="header">
                  <h3>
                    Compare Application List
                  </h3>
                </template>-->
                <template slot="thead">
                  <vs-th sort-key="email">
                    Id
                  </vs-th>
                  <vs-th sort-key="id">
                    sales_doc
                  </vs-th>
                  <vs-th sort-key="id">
                    article
                  </vs-th>
                  <vs-th sort-key="email">
                    billing_date
                  </vs-th>
                  <vs-th sort-key="email">
                    bisiness_area
                  </vs-th>
                  <vs-th sort-key="id">
                    customer_name
                  </vs-th>

                  <vs-th sort-key="id">
                    phone
                  </vs-th>
                  <vs-th sort-key="id">
                    email
                  </vs-th>
                  <vs-th sort-key="id">
                    nid
                  </vs-th>
                  <vs-th sort-key="id">
                    is_found
                  </vs-th>


                </template>

                <template slot-scope="{data}">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].id">
                      {{data[indextr].id}}
                    </vs-td>
                    <vs-td :data="data[indextr].sales_doc">
                      {{data[indextr].sales_doc}}
                    </vs-td>
                    <vs-td :data="data[indextr].article">
                      {{data[indextr].article}}
                    </vs-td>

                    <vs-td :data="data[indextr].billing_date">
                      {{data[indextr].billing_date}}
                    </vs-td>

                    <vs-td :data="data[indextr].bisiness_area">
                      {{data[indextr].bisiness_area}}
                    </vs-td>

                    <vs-td :data="data[indextr].customer_name">
                      {{data[indextr].customer_name}}
                    </vs-td>

                    <vs-td :data="data[indextr].mobile_number">
                      {{data[indextr].mobile_number}}
                    </vs-td>

                    <vs-td :data="data[indextr].email">
                      {{data[indextr].email}}
                    </vs-td>

                    <vs-td :data="data[indextr].nid">
                      {{data[indextr].nid}}
                    </vs-td>

                    <vs-td :data="data[indextr].is_found_match">
                      {{data[indextr].is_found_match}}
                    </vs-td>


                  </vs-tr>
                </template>
              </vs-table>


      </vx-card>
    </div>


    <!--<template>
      <div class="demo-alignment">
        <vs-popup class="holamundo" title="Send Review" :active.sync="popupActive2">
          <vs-textarea v-model="review" placeholder="Input review here"></vs-textarea>
          <vs-button color="primary" type="filled" @click="sendReview(review, refId)">Send Review</vs-button>
        </vs-popup>
      </div>
    </template>-->
  </div>

</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        file: null,
        refId: '',
        review: '',
        selected: [],
        popupActive2: false,
        selectedPgae: 1,
        perPage: 0,
        queryParamLength: 3,
        searchParam: {
          sales_doc: '',
          mobile_number: ''
        },
        uploadbtn: true
      }
    },
    watch: {
      compareExcelDone() {
        this.$store.dispatch('getAllCompareList', this.selectedPgae)
      }
    },
    computed: {
      ...mapGetters(['compareData', 'meta', 'excelUploadLoad', 'uploadExcelDone', 'excelCompareLoad', 'compareExcelDone'])
    },
    mounted() {
      this.$store.dispatch('getAllCompareList', this.selectedPgae)
      //this.$store.dispatch('getExcel', '?page=' + this.selectedPgae);
    },
    methods: {
      selectedFile(event) {
        console.log(event);
        this.file = event.target.files[0]
      },
      uploadExcel() {
        let formData = new FormData();
        formData.append('file', this.file);
        for (var pair of formData.entries()) {
          console.log(pair[0] + ', ' + pair[1]);
        }
        this.$store.dispatch('uploadExcel', formData);
        //this.$store.dispatch('getExcel', '?page=' + this.selectedPgae);
      },
      compareApp() {
        this.$store.dispatch('compareDataForExcel')
        this.uploadbtn = false
      },
      downloadPur() {
        this.excelFile = 'https://ho.butterflygroupbd.com/showroom-backend/api/downloadComparedExcel'
        return window.open(this.excelFile)
      },
      handleChangePage(page) {
        console.log('Page====>', page)
        this.selectedPgae = page
        this.$store.dispatch('getAllCompareList', this.selectedPgae)
      },
      /*searchExcelData() {
        console.log("Exceell Data ===> ", this.searchParam);
        let val = Object.keys(this.searchParam)
          .filter((k) => this.searchParam[k] != '')
          .reduce((a, k) => ({...a, [k]: this.searchParam[k]}), {});
        if (Object.keys(val).length > this.queryParamLength) {
          this.searchParam.page = 1;
          this.selectedPgae = 1;
          this.queryParamLength = Object.keys(val).length;
        }
        console.log("Return==>", Object.keys(val).length);

        if (Object.keys(val).length > 1) {
          let pv = "filter[sales_doc]=" + val.sales_doc + "&filter[mobile_number]=" + val.mobile_number;
          this.$store.dispatch('searchExcelData', pv);
        } else if (Object.keys(val).length === 1) {
          if (val.hasOwnProperty('sales_doc')) {
            let pv = "filter[sales_doc]=" + val.sales_doc;
            this.$store.dispatch('searchExcelData', pv);
          } else {
            let pv = "filter[mobile_number]=" + val.mobile_number;
            this.$store.dispatch('searchExcelData', pv);
          }
        } else {
          this.$store.dispatch('getExcel');
        }

      },*/
      /*reviewCompleate(id) {
        this.$store.dispatch('compleateReview', id).then(res => {
          console.log("Log--->", res);
          if (res === undefined) {
            this.$vs.notify({
              title: 'Success',
              text: 'Successfully Reviewed.',
              color: 'success',
              position: 'top-right'
            });
          } else {
            this.error = res.data;
            this.$vs.notify({
              title: 'Failed!',
              text: res.message,
              color: 'danger',
              position: 'top-right'
            })
          }
        });
      },*/
/*      sendRef(id) {
        this.refId = id;
      },
      sendReview(review, refId) {
        let send = {
          id: refId,
          review: review
        };
        this.popupActive2 = false;
        this.$store.dispatch('sendReview', send).then(res => {
          console.log("Log--->", res);
          if (res === undefined) {
            this.$vs.notify({
              title: 'Success',
              text: 'Successfully Send Review.',
              color: 'success',
              position: 'top-right'
            });
          } else {
            this.error = res.data;
            this.$vs.notify({
              title: 'Failed!',
              text: res.message,
              color: 'danger',
              position: 'top-right'
            })
          }
        });
      },
      sendMailForIncApp(id) {
        this.$store.dispatch('sendMailForIncApp', id);
      },*/
      /*handleChangePage(page) {
        this.selectedPgae = page;
        this.$store.dispatch('getExcel', '?page=' + this.selectedPgae);
      }*/
    }
  }
</script>
<style scoped>
  .mismatch {
    background-color: #ea5455;
    font-weight: 700;
    color: #fff;
  }

  .match {
    background-color: #28c76f;
  }

  table.vs-table.vs-table--tbody-table tr {
    border-bottom: 1px solid #f8f8f8;
  }
</style>
